export default {
  'ec.guide.zxbl':'在线办理',
  'ec.guide.zxbl.zbzc':'暂不支持',
  'ec.guide.sc':'收藏',
}